// Single source of truth for "is this MSA's own product, or a partner's".
//
// Mirrors the backend's _is_msa_product (server.py): own brand means the brand
// field is empty/MSA AND the product is not in the partner category. Of ~3070
// products only 9 are own-brand, so anything claimed about MSA products must be
// gated on this — see the free-shipping rule below.
export const isOwnBrand = (p) => {
  if (!p) return false;
  const brand = String(p.brand ?? '').trim().toUpperCase();
  const brandIsOwn = brand === '' || brand === 'MSA' || brand === 'МСА';
  const cats = Array.isArray(p.categories) ? p.categories : [];
  return brandIsOwn && !cats.includes('partner') && p.category !== 'partner';
};

// Free delivery is promised on MSA-brand goods only, so it is measured against
// the MSA part of the basket, never the whole total. Cart lines saved before
// this shipped carry no brand field; `isOwn` is stored at add time and a missing
// value counts as "not MSA" so the site never over-promises.
export const msaSubtotal = (items = []) =>
  items.reduce((sum, i) => (i.isOwn ? sum + Number(i.price || 0) * Number(i.qty || 0) : sum), 0);
